import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
// import { useGetConsentFormDetailsQuery, useSaveConsentFormMutation } from 'store/services/consentForm';
import parse from "html-react-parser";
import LoadingIndicator from 'components/shared/LoadingIndicator';
import { usePreviewConsentFormQuery } from 'store/services/appointment';
import ErrorComponent from "components/shared/ErrorComponent";
import { Col, Row } from "react-bootstrap"
import { useLazyGetFileUrlQuery } from 'store/services/utility';
import { useGetConsentFormDetailsQuery } from 'store/services/consent';
import { parseConsentForm } from 'helpers/consentForm';
const ViewConsentForm = () => {

    const { id, mode } = useParams();
    const navigate = useNavigate();
    const [viewParentSignature, setViewParentSignature] = useState(null)

    const { data, isLoading } = useGetConsentFormDetailsQuery({ id });
    const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();
    // const { data, isLoading } = usePreviewConsentFormQuery({ id });
    const [errorMessage, setErrorMessage] = useState(null);
    const isSubmitted = true

    const parsedHtml = useMemo(() => {
        if (!data) {
            return null;
        }
        let submittedValues = null;
        if (mode !== "preview") {
            try {
                submittedValues = data?.submission || {};
            } catch (err) {
                console.error("Error viewing consent form", err);
            }
        }
        return parseConsentForm(data?.formAssignedAdmin?.consent_form, submittedValues, isSubmitted);
    }, [data])

    console.log('data', parsedHtml)

    const handleViewSignature = async (parentSignature) => {

        try {
            const result = await getFileUrl(parentSignature);
            if (result?.error) return;

            const url = result?.data
            setViewParentSignature(url)

        } catch (err) { console.error("Error view pdf", err); }
    };

    useEffect(() => {
        if (data?.signature_image) {
            handleViewSignature(data?.signature_image)
        }
    }, [data])


    return (
        (isLoading ) ? <LoadingIndicator /> : <div className='consent-form-wrapper'>
            <Col lg="12 border-bottom py-2" style={{ "background": "white", "position": "fixed" }}>
                <Row>
                    <Col xs={2}>
                        <div className="pageHead d-flex align-items-center justify-content-between flex-wrap gap-10">
                            <div className="left mt-2 px-4">
                                <Link
                                    className="themeBlue fw-sbold"
                                    style={{ textDecoration: "underline" }}
                                    to={-1}
                                >
                                    <i class="fa fa-arrow-left me-1" aria-hidden="true"></i>
                                    Back
                                </Link>
                            </div>
                        </div>
                    </Col>
                    <Col xs={8}>
                        <h5 class="mt-2 fw-bold text-capitalize">{data?.formAssignedAdmin?.title || "--"}</h5>
                    </Col>
                    {/* <Col xs={4}>
                                <h5 class="mt-2 fw-bold text-capitalize">{data?.formAssigned?.verify}</h5>
                            </Col> */}
                </Row>
            </Col>
            {parsedHtml ? (
                <div className='p-4 consent-fill-form'>
                    <form onSubmit={"handleSubmit"}>
                        {
                            parse(parsedHtml || "")
                        }
                        {/* <div className='mt-5'>
                            {errorMessage && <div className='my-2 error'>{errorMessage}</div>}
                            <Button
                                type="submit"
                                className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                                disabled={isSubmitted || saveFormLoading}
                            >
                                {saveFormLoading ? <LoadingIndicator color='#fff' inline /> : "Submit"}
                            </Button>
                        </div> */}
                    </form>
                    <Row style={{ padding: "0px 50px" }} className="my-4">
                        <Col lg={4} md={6} sm={12}>
                            <div
                                style={{
                                    padding: "30px",
                                    border: "1px solid #ddd",
                                    borderRadius: "12px",
                                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                    textAlign: "center",
                                    backgroundColor: "#fafafa",
                                }}
                            >
                                {viewParentSignature && (
                                    <img
                                        src={viewParentSignature}
                                        alt="Parent's Signature"
                                        style={{
                                            maxWidth: "100%",
                                            height: "auto",
                                            marginBottom: "15px",
                                            borderRadius: "8px",
                                        }}
                                    />
                                )}
                                <p
                                    style={{
                                        fontSize: "18px",
                                        fontWeight: "500",
                                        margin: "0",
                                        color: "#333",
                                    }}
                                >
                                    Parent's Signature
                                </p>
                            </div>
                        </Col>
                    </Row>
                </div>
            ) : (
                <ErrorComponent />
            )}
        </div>
    )
}

export default ViewConsentForm